import {hexWithAlpha} from './../../../../shared/components/gradientView/index';
import {useStyles} from './../../../../shared/hooks/styles';

export const GetStyles = () => {
  return useStyles(({theme}) => ({
    container: {},
    noData: {
      paddingVertical: 24,
      color: theme.color.gray500,
    },
    item: {
      borderWidth: 1,
      borderColor: theme.color.gray300,
      borderRadius: 14,
      overflow: 'hidden',
      marginBottom: 16,
    },
    itemHead: {
      paddingHorizontal: 20,
      paddingVertical: 8,
    },
    itemBody: {
      paddingHorizontal: 20,
      paddingVertical: 8,
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: hexWithAlpha(theme.color.blue200, 0.15),
    },
    itemBodyDate: {
      color: theme.color.gray500,
    },
  }));
};
